import React from "react";
import InfoIcon from "../../../assets/images/info-circle-white.png";

const GameInfoModal = ({ isOpen, setOpen, data }) => {
 
  if (!isOpen) return null;


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-gray-800 p-3 p-sm-3 p-md-6 p-lg-6 w-1/3 rounded-lg shadow-lg  ">
        <div className="w-full justify-content-between d-flex rounded">

          <p className="text-sm text-white mb-0 font-semibold d-flex rounded ">
          <img src={InfoIcon} className="coin-img me-2 " alt="info" />
            Game Info</p>
          <button
            className=" text-gray-500 hover:text-gray-800"
            onClick={() => {
              setOpen(!isOpen);
            }}
          >
            ✖
          </button>
        </div>

        <div>
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
           <div className="p-2 yellow-title w-1/3 m-auto text-center rounded font-semibold">Rules</div>
           <div>
            <p className="text-white">Rule 1</p>
            <p className="text-white">Rule 2</p>
            <p className="text-white">Rule 3</p>
           </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameInfoModal;
